import { PlannedOccurrence, Task, Timeslot, Timestamp } from '@griply/types';

import { getActiveSchedule } from './schedules/get-active-schedule';

export type GetTaskTimeslotOptions = {
  today: Timestamp;
  plannedOccurrence?: PlannedOccurrence;
};

// an occurrence's timeslot wins even when null: a cleared time stays cleared (today-based; getOccurrenceTimeslot resolves a specific date)
export const getTaskTimeslot = (
  task: Task,
  { today, plannedOccurrence }: GetTaskTimeslotOptions,
): Timeslot | null | undefined => {
  if (plannedOccurrence) {
    return plannedOccurrence.timeslot;
  }

  const activeSchedule = getActiveSchedule(task.schedules, today);
  if (activeSchedule) {
    return activeSchedule.timeslot;
  }

  return task.timeslot;
};
